/* eslint-disable require-unicode-regexp */
export const stateNameToAbbreviation = (name: string) => {
    const states = {
        arizona: 'AZ',
        alabama: 'AL',
        alaska: 'AK',
        arkansas: 'AR',
        california: 'CA',
        colorado: 'CO',
        connecticut: 'CT',
        'district of columbia': 'DC',
        delaware: 'DE',
        florida: 'FL',
        georgia: 'GA',
        hawaii: 'HI',
        idaho: 'ID',
        illinois: 'IL',
        indiana: 'IN',
        iowa: 'IA',
        kansas: 'KS',
        kentucky: 'KY',
        louisiana: 'LA',
        maine: 'ME',
        maryland: 'MD',
        massachusetts: 'MA',
        michigan: 'MI',
        minnesota: 'MN',
        mississippi: 'MS',
        missouri: 'MO',
        montana: 'MT',
        nebraska: 'NE',
        nevada: 'NV',
        'new hampshire': 'NH',
        'new jersey': 'NJ',
        'new mexico': 'NM',
        'new york': 'NY',
        'north carolina': 'NC',
        'north dakota': 'ND',
        ohio: 'OH',
        oklahoma: 'OK',
        oregon: 'OR',
        pennsylvania: 'PA',
        'rhode island': 'RI',
        'south carolina': 'SC',
        'south dakota': 'SD',
        tennessee: 'TN',
        texas: 'TX',
        utah: 'UT',
        vermont: 'VT',
        virginia: 'VA',
        washington: 'WA',
        'west virginia': 'WV',
        wisconsin: 'WI',
        wyoming: 'WY',
        'american samoa': 'AS',
        guam: 'GU',
        'northern mariana islands': 'MP',
        'puerto rico': 'PR',
        'us virgin islands': 'VI',
        'us minor outlying islands': 'UM',
    };

    const a = name
        .trim()
        .replace(/[^\w ]/g, '')
        .toLowerCase();
    // @ts-expect-error error
    if (states[a] !== null) {
        // @ts-expect-error error
        return states[a];
    }

    return null;
};
